import { render, staticRenderFns } from "./AddDocumentLinkDlg.vue?vue&type=template&id=5639923f&"
import script from "./AddDocumentLinkDlg.vue?vue&type=script&lang=js&"
export * from "./AddDocumentLinkDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports